
interface GridModalAuditoriaType {
  antes: any;
  depois: any;
}

export function GridModalAuditoria({ antes, depois }: GridModalAuditoriaType) {
  return (
    <div className="flex w-[59rem] mt-3" style={{ border: "1px solid black" }}>
      <Grid value={antes} title="Antes" border />

      <Grid value={depois} title="Depois" />

    </div>
  )
}

interface GridType {
  value: any;
  title: string;
  border?: boolean;
}

function Grid({value, title, border}: GridType) {
  return (
    <div className={`flex flex-col w-[29.5rem] ${border && 'border-solid border-r-[1px] border-gray-800'}`} >
        <strong className="flex items-center h-7 pl-2 border-solid border-b-[1px] border-gray-800">{title}</strong>

        <span className="mx-2 mt-2">{'{'}</span>
        {value?.map((item: any, index: number) => {
          return (
            <span key={index} className="ml-4">
              {item},
            </span>
          )
        })}
        <span className="mx-2 mb-2">{'}'}</span>

      </div>
  );
}
